<template>
    <div class="login">
        <div class="card">
            <div class="brand">
                <div class="title">ProxyAdmin</div>
                <div class="sub">Đăng nhập để tiếp tục</div>
            </div>

            <el-form ref="form" :model="form" :rules="rules" label-position="left">
                <el-form-item label="Email" prop="email">
                    <el-input v-model="form.email" autocomplete="email" placeholder="admin@genrouter.com" />
                </el-form-item>
                <el-form-item label="Mật khẩu" prop="password">
                    <el-input v-model="form.password" type="password" autocomplete="current-password"
                        placeholder="••••••••" show-password />
                </el-form-item>

                <div class="actions">
                    <el-button type="primary" :loading="loading" style="width: 100%" @click="onSubmit">
                        Đăng nhập
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { setToken, setRefreshToken, setUser } from '../../utils/auth'
import { loginApi } from '../../api/auth'

export default {
    name: 'LoginView',
    data() {
        return {
            loading: false,
            form: {
                email: '',
                password: ''
            },
            rules: {
                email: [{ required: true, message: 'Nhập email', trigger: 'blur' }],
                password: [{ required: true, message: 'Nhập mật khẩu', trigger: 'blur' }]
            }
        }
    },
    methods: {
        onSubmit() {
            this.$refs.form.validate(async (ok) => {
                if (!ok) return
                this.loading = true
                try {
                    const res = await loginApi({
                        email: this.form.email,
                        password: this.form.password
                    })

                    // Backend trả:
                    // { data: { access_token, refresh_token }, message }
                    const data = res && res.data ? res.data : res
                    if (!data || !data.access_token) {
                        this.$message.error('Login API không trả access_token')
                        return
                    }

                    setToken(data.access_token)
                    if (data.refresh_token) setRefreshToken(data.refresh_token)
                    if (data.user) setUser(data.user)

                    const redirect = (this.$route && this.$route.query && this.$route.query.redirect) ? this.$route.query.redirect : '/dashboard'
                    this.$router.replace(redirect)
                } catch (err) {
                    const msg =
                        (err && err.response && err.response.data && (err.response.data.message || err.response.data.error)) ||
                        (err && err.message) ||
                        'Đăng nhập thất bại'
                    this.$message.error(msg)
                } finally {
                    this.loading = false
                }
            })
        }
    }
}
</script>

<style scoped>
.login {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #101622;
}

.card {
    width: 420px;
    max-width: 100%;
    padding: 22px;
    border-radius: 14px;
    background: #1a2235;
    border: 1px solid #232f48;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.brand {
    margin-bottom: 12px;
}

.title {
    font-size: 20px;
    font-weight: 900;
    color: #ffffff;
}

.sub {
    margin-top: 6px;
    font-size: 12px;
    color: #92a4c9;
}

.actions {
    margin-top: 10px;
    display: grid;
    gap: 6px;
}

.hint {
    margin-top: 12px;
    font-size: 12px;
    color: #92a4c9;
}
</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue